import { useContext, useEffect, useState } from 'react';
import useTravelExpenseService from '../../../app/services/hooks/useTravelExpenseService';
import LazyLoading from '../../../components/LazyLoading';
import { TravelExpenseDataForm } from '../../../app/models/TravelExpense';
import TravelExpensesFormContainer from './TravelExpensesFormContainer';
import { AppContext } from '../../../contexts/AppContext';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import { EventType } from '../../../app/models/EventType';

interface Props {
    travelExpenseId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const TravelExpenseEdit = ({ travelExpenseId, onSaved, onCancel, onError }: Props) => {
    const {
        fetchingEditTravelExpenses,
        editTravelExpense,
        fetchingUpdateTravelExpenses,
        updateTravelExpense
    } = useTravelExpenseService();
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [errorFields, setErrorFields] = useState({});
    const [travelExpense, setTravelExpense] = useState<TravelExpenseDataForm>({ budget: '' });
    const [eventTypes, setEventTypes] = useState<EventType[]>([]);
    const [currencies, setCurrencies] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando viático...');
        editTravelExpense(travelExpenseId, {
            onSuccess: (response: ServiceResponse) => {
                setEventTypes(response.data.event_types);
                setCurrencies(response.data.currencies);
                const _travel_expense = response.data.travel_expense;
                _travel_expense.event_types = response.data.travel_expense.event_types.map(
                    (eventType: any) => {
                        return {
                            value: eventType.id,
                            label: eventType.name
                        };
                    }
                );
                setTravelExpense(_travel_expense);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando viático...');
        updateTravelExpense(travelExpenseId, travelExpense, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditTravelExpenses ? (
        <LazyLoading height="300" />
    ) : (
        <TravelExpensesFormContainer
            fetching={fetchingUpdateTravelExpenses}
            action={update}
            cancel={cancel}
            travelExpense={travelExpense}
            setTravelExpense={setTravelExpense}
            eventTypes={eventTypes}
            errorFields={errorFields}
            currencies={currencies}
        />
    );
};

export default TravelExpenseEdit;
